/**
 * Utility functions for dimension management
 */

/**
 * Checks if an image's dimensions match the expected aspect ratio within the specified error margin
 * @param imageWidth The width of the image
 * @param imageHeight The height of the image
 * @param expectedRatio The expected aspect ratio (width/height)
 * @param errorMargin The allowed error margin as a decimal (default: 0.05 or 5%)
 * @returns boolean indicating if the aspect ratio is valid
 */
export const isAspectRatioValid = (
  imageWidth: number,
  imageHeight: number,
  expectedRatio: number,
  errorMargin = 0.05
): boolean => {
  // Handle invalid dimensions
  if (imageWidth <= 0 || imageHeight <= 0) return false;

  const actualRatio = imageWidth / imageHeight;
  const lowerBound = expectedRatio * (1 - errorMargin);
  const upperBound = expectedRatio * (1 + errorMargin);

  return actualRatio >= lowerBound && actualRatio <= upperBound;
}
